import { render, staticRenderFns } from "./buildingGiftRecord.vue?vue&type=template&id=4959b064&scoped=true"
import script from "./buildingGiftRecord.vue?vue&type=script&lang=js"
export * from "./buildingGiftRecord.vue?vue&type=script&lang=js"
import style0 from "./buildingGiftRecord.vue?vue&type=style&index=0&id=4959b064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959b064",
  null
  
)

export default component.exports